import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import FilterIcon from "../basicInfoForm/images/filterIcon.png";
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';

import "./requisitioncard.css";

import getRequisitionsDetails from "../../apis/requisitionDetails/getRequisitionsDetails";
import { DateTime } from "luxon";
import Skeleton from '@mui/material/Skeleton';
import { useNavigate } from "react-router-dom";
import getAllRecruiterRequisitions from "../../apis/requisitionDetails/getAllRecruiterRequisitions";
import getRecruiterLeaderRequisitionsDetails from "../../apis/requisitionDetails/getRecruiterLeaderRequisitionsDetails";
import config from "../../Config.json";
import searchRequisition from "../../apis/requisitionDetails/searchRequisition";
import { useDebounce } from "../recruitmentLeader/hook";
import getTeamLeaderRequisitionsDetails from "../../apis/requisitionDetails/getTeamLeaderRequisitionsDetails";

const RequisitionListCard = (props) => {
  const {
    status,
    selectedFilter,
    filterChange,
    requisitionStatus,
    isSearchRequisition,
    userType,
    idContextTest,
    userRecruitmentpartnerId,
    searchpayload,
    isSearching,
    userRole,
    userRecords,
    setSearchComplete,
    hideHeader = false,
    externalSearchText = "",
    externalData = null,
    isLoading = null
  } = props;
  const limit = isSearchRequisition ? 10 : 5;
  const [reqCard, setRecCard] = useState(externalData || []);
  const [isDataLoading, setIsDataLoading] = useState(isLoading !== null ? isLoading : true);
  const [searchText, setSearchText] = useState(externalSearchText);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const debouncedSearchText = useDebounce(externalSearchText || searchText, 700);

  // Handle external data changes
  useEffect(() => {
    if (externalData !== null) {
      setRecCard(externalData);
    }
  }, [externalData]);

  // Handle external loading state changes
  useEffect(() => {
    if (isLoading !== null) {
      setIsDataLoading(isLoading);
    }
  }, [isLoading]);


  const history = useNavigate();

  const goToRequisitionDetails = (item) => {
    history(`/requisition-details/${item.requisitionId}`,
      {
        state: { id: idContextTest, userRecruitmentpartnerId: userRecruitmentpartnerId, userType: userType, userRecords: userRecords, userRole: userRole },
      });
  };


  function convertDate(str) {
    if (str === "") {
      return "";
    }
    else {
      let date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
  }


  const getSearchRequisitionResult = async (offset = 0) => {
    try {

      let searchpayload_init = searchpayload;

      let payload = searchpayload_init;
      if (userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator")) {
        payload.organizationId = userRecruitmentpartnerId;
        payload.role = "Organization Admin"
      }
      else if (userType === "Organization Admin" || (userType === "Admin" && userRole === "Organization Admin")) {
        payload.organizationId = userRecruitmentpartnerId;
        payload.role = userType === "Admin" ? userRole : userType
      }
      else if (userType === "Recruitment Leader" || (userType === "Admin" && userRole === "Recruitment Leader")) {
        payload.recruitmentLeaderId = idContextTest;
        payload.role = userType === "Admin" ? userRole : userType
      }
      else if (userType === "Team Leader" || (userType === "Admin" && userRole === "Team Leader")) {
        payload.teamLeaderId = idContextTest;
        payload.role = userType === "Admin" ? userRole : userType
      }

      else if (userType === "Recruiter" || (userType === "Admin" && userRole === "Recruiter")) {
        payload.recruiterId = idContextTest;
        payload.role = userType === "Admin" ? userRole : userType
      }

      payload.createdOn_from = payload.createdOn_from ? convertDate(payload.createdOn_from) : "";
      payload.createdOn_to = payload.createdOn_to ? convertDate(payload.createdOn_to) : "";
      payload.updatedOn_from = payload.updatedOn_from ? convertDate(payload.updatedOn_from) : "";
      payload.updatedOn_to = payload.updatedOn_to ? convertDate(payload.updatedOn_to) : "";
      payload.userRecruitmentpartnerId = userRecruitmentpartnerId;
      payload.userId = idContextTest;
      let response = await searchRequisition(offset,
        limit,
        payload);
      let responseObj = {};

      responseObj.data = response.data.data.requisitions
      responseObj.totalCount = response.data.data.totalCount

      if (offset === 0) {
        setSearchComplete(true)
      }

      return responseObj;

    } catch (error) {
      console.log(error, "error");
    }
  };

  const API = async (offset = 0) => {
    try {

      if (isSearchRequisition) {
        let responseObj = getSearchRequisitionResult(offset);
        return responseObj;
      }
      else {

        let response;

        if (userType === "Recruiter" || (userType === "Admin" && userRole === "Recruiter")) {
          response = await getAllRecruiterRequisitions(
            offset,
            limit,
            status === ""
              ? requisitionStatus?.filter((item, i) => item.statusCode === config?.requisitionStatusCodes?.OPEN)[0]
                ?.statusCode
              : status,
            selectedFilter,
            idContextTest,
            searchText,
            userRecruitmentpartnerId
          );
        } else if (userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator")) {
          let isOrgAdmin = false;
          response = await getRequisitionsDetails(
            offset,
            limit,
            status === ""
              ? requisitionStatus?.filter((item, i) => item.name === "OPEN")[0]
                ?.statusCode
              : status,
            selectedFilter,
            userRecruitmentpartnerId,
            isOrgAdmin,
            searchText,
            idContextTest
          );
        } else if (userType === "Recruitment Leader" || (userType === "Admin" && userRole === "Recruitment Leader")) {
          response = await getRecruiterLeaderRequisitionsDetails(
            offset,
            limit,
            status === ""
              ? requisitionStatus?.filter((item, i) => item.name === "OPEN")[0]
                ?.statusCode
              : status,
            selectedFilter,
            idContextTest,
            searchText,
            userRecruitmentpartnerId
          );
        }
        else if (userType === "Team Leader" || (userType === "Admin" && userRole === "Team Leader")) {
          response = await getTeamLeaderRequisitionsDetails(
            offset,
            limit,
            status === ""
              ? requisitionStatus?.filter((item, i) => item.name === "OPEN")[0]
                ?.statusCode
              : status,
            selectedFilter,
            idContextTest,
            searchText,
            userRecruitmentpartnerId
          )
        }
        else if (userType === "Organization Admin" || (userType === "Admin" && userRole === "Organization Admin")) {
          let isOrgAdmin = true;
          response = await getRequisitionsDetails(
            offset,
            limit,
            status === ""
              ? requisitionStatus?.filter((item, i) => item.name === "OPEN")[0]
                ?.statusCode
              : status,
            selectedFilter,
            userRecruitmentpartnerId,
            isOrgAdmin,
            searchText,
            idContextTest
          );
        }
        let responseObj = {};
        responseObj.data = response.data.data.requisitions
        responseObj.totalCount = response.data.data.totalCount

        return responseObj;
      }
    } catch (error) {
      console.log(error, "error");
    }
  };


  const formatDate = (dateString) => {
    // Parse the date string using Luxon
    const dateTime = DateTime.fromISO(dateString);

    // Format the date using Luxon's format method
    const formattedDate = dateTime.toFormat('MMMM dd, yyyy');

    return formattedDate;
  };

  const filterChangeToCover = (str) => {
    let subStatusArr = requisitionStatus?.filter(
      (item, i) => item.statusCode === config?.requisitionStatusCodes?.OPEN
    )[0]?.subList;
    let code = str
      ? subStatusArr.filter((item, i) => item.subName === str)[0]?._id
      : "";
    filterChange("covered", code);
  };

  const getRequisitionStatusName = (statusCode) => {
    return requisitionStatus?.filter((item, i) => item._id === statusCode)[0]
      ?.name;
  };

  const searchTextChangeHandler = (event) => {
    setSearchText(event.target.value);
  }

  // Load more data function
  const loadMoreData = async () => {
    try {
      setIsLoadingMore(true);
      let responseObj = await API(reqCard.length);
      if (responseObj && responseObj.data) {
        setRecCard((prev) => [...prev, ...responseObj.data]);
        setTotalCount(responseObj.totalCount);
      }
      setIsLoadingMore(false);
    } catch (error) {
      console.error('Error loading more data:', error);
      setIsLoadingMore(false);
    }
  };


  useEffect(() => {
    // Skip API calls if external data is provided
    if (externalData !== null) {
      return;
    }

    let isMounted = true; // Flag to track whether the component is mounted

    const fetchData = async () => {
      try {
        setIsDataLoading(true)
        let responseObj = await API(0);


        if (isMounted) {
          setRecCard(responseObj?.data)
          setTotalCount(responseObj?.totalCount || 0)
          setIsDataLoading(false)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (userRecruitmentpartnerId) {
      if (requisitionStatus.length !== 0)
        fetchData();
    }
    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [requisitionStatus, status, selectedFilter, isSearching, debouncedSearchText, userRecruitmentpartnerId, externalData]);

  // Sync external search text
  useEffect(() => {
    if (externalSearchText !== undefined) {
      setSearchText(externalSearchText);
    }
  }, [externalSearchText]);

  return (
    <div
    >
      {/* search header and filters */}
      {(!hideHeader && !isSearchRequisition) && (
        <div className="secCard_header">
          <span className="sec_req_cards">
            {(status === "ALL" && selectedFilter?.priority === "High") ? "High Priority" :
              !status
                ? "OPEN"
                : status === "ALL"
                  ? "All"
                  : requisitionStatus
                    ?.filter((item, i) => item.statusCode === status)[0]
                    ?.name //?.charAt(0)
                    .toUpperCase()
              //   +
              // requisitionStatus
              //   ?.filter((item, i) => item.statusCode === status)[0]
              //   ?.name?.slice //(1)
              //   .toLowerCase()
            }{" "}
            Requisitions
          </span>

          <OutlinedInput
            className="searchbar_requisition"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => searchTextChangeHandler(e)}
            endAdornment={
              <InputAdornment position="end">
                <SearchIcon className="searchIcon_searchBar" />
              </InputAdornment>
            }
          />
        </div>
      )}
      {/* Filter options */}
      {(!hideHeader && !isSearchRequisition && userType !== "MIS Operator") && (

          <div className="filterNav">
            <div className="secCard_header_components">
              <button
                className={
                  selectedFilter.covered
                    ? "filterBtnStyle_selected"
                    : "filterBtnStyle"
                }
                onClick={(e) =>
                  selectedFilter.covered
                    ? filterChangeToCover("")
                    : filterChangeToCover("COVERED")
                }
              >
                <span className="filterTexts">Covered</span>
                <img src={FilterIcon} className="filterIcon" alt="filter-icon" />
              </button>
            </div>
            <div className="secCard_header_components">
              <button
                className={
                  selectedFilter?.priority
                    ? "filterBtnStyle_selected"
                    : "filterBtnStyle"
                }
                onClick={(e) =>
                  selectedFilter?.priority
                    ? filterChange("priority", "")
                    : filterChange("priority", "High")
                }
              >
                <span className="filterTexts">High Priority</span>
                <img src={FilterIcon} className="filterIcon" alt="filter-icon" />
              </button>
            </div>
            <div className="secCard_header_components">
              <button
                className={
                  selectedFilter.latestDate
                    ? "filterBtnStyle_selected"
                    : "filterBtnStyle"
                }
                onClick={(e) =>
                  selectedFilter.latestDate
                    ? filterChange("latestDate", false)
                    : filterChange("latestDate", true)
                }
              >
                <span className="filterTexts">Latest Date</span>
                <img src={FilterIcon} className="filterIcon" alt="filter-icon" />
              </button>
            </div>
          </div>
      )}
      {/* requisition cards */}
      <div
        className={
          isSearchRequisition
            ? "sec_card_content_searchRequisition"
            : "sec_card_content"
        }
      >
        {isDataLoading ? (
          <>
            {[...Array(9)].map((item, i) => {
              return (
                <Skeleton
                  variant="rect"
                  width="98%"
                  height={120}
                  animation="wave"
                  className="skeletonStyle"
                  key={'skeleton' + i}
                />
              );
            })}
          </>
        ) : reqCard ? (reqCard.length > 0 ? (
          <>
            {reqCard.map((item, i) => {

              let itemValue;
              isSearchRequisition ? itemValue =
                userType === "MIS Operator" || userType === "Organization Admin" || userType === "Recruitment Leader"
                  || ((userType === "Admin" && userRole === "MIS Operator") || (userType === "Admin" && userRole === "Organization Admin") || (userType === "Admin" && userRole === "Recruitment Leader"))
                  ? item : item?.requisitionDetails
                : itemValue = userType === "MIS Operator" || userType === "Organization Admin"
                  || ((userType === "Admin" && userRole === "MIS Operator") || (userType === "Admin" && userRole === "Organization Admin"))
                  ? item : item?.requisitionDetails;
              return (
                <div key={`reqCard+${i}`} className="requisition-card">
                  <div 
                    className={`card-content ${itemValue?.priority?.toLowerCase() === "low"
                      ? "green-card"
                      : itemValue?.priority?.toLowerCase() === "high"
                        ? "red-card"
                        : "blue-card"
                      }`}
                    onClick={() => goToRequisitionDetails(itemValue)}
                  >
                    <div className="card-details">
                      <div className="detail-item">
                        <span className="detail-label_requisitionCard">Reference ID</span>
                        <span className="detail-value_requisitionCard ">{itemValue?.reqreferenceId}</span>
                      </div>

                      {(isSearchRequisition && (userType === "Organization Admin" || userType === "MIS Operator" || (userType === "Admin" && (userRole === "Organization Admin" || userRole === "MIS Operator"))))
                        || (userType === "Organization Admin" || (userType === "Admin" && userRole === "Organization Admin"))
                        ?
                        <div className="detail-item">
                          <span className="detail-label_requisitionCard">Created By</span>
                          <span className="detail-value_requisitionCard ">{itemValue?.misOperatorData?.email}</span>
                        </div>
                        : null}

                      <div className="detail-item">
                        <span className="detail-label_requisitionCard">Client Name</span>
                        <span className="detail-value_requisitionCard ">{itemValue?.clientDetails?.clientName}</span>
                      </div>

                      <div className="detail-item">
                        <span className="detail-label_requisitionCard">Status</span>
                        <span className="detail-value_requisitionCard ">
                          {getRequisitionStatusName(itemValue?.status.statusCodeId)}
                        </span>
                      </div>

                      <div className="detail-item">
                        <span className="detail-label_requisitionCard">Primary Skill</span>
                        <span className="detail-value_requisitionCard ">{itemValue?.primarySkill}</span>
                      </div>

                      <div className="detail-item">
                        <span className="detail-label_requisitionCard">Placement Type</span>
                        <span className="detail-value_requisitionCard ">{itemValue?.placementType}</span>
                      </div>

                      <div className="detail-item">
                        <span className="detail-label_requisitionCard">Date</span>
                        <span className="detail-value_requisitionCard ">{formatDate(itemValue?.created_at)}</span>
                      </div>

                      {userType === "MIS Operator" || userType === "Organization Admin" ||
                        ((userType === "Admin" && userRole === "MIS Operator") || (userType === "Admin" && userRole === "Organization Admin"))
                        ?
                        <div className="detail-item">
                          <span className="detail-label_requisitionCard">Contact</span>
                          <span className="detail-value_requisitionCard ">{itemValue?.recruitmentLeaderData?.displayName}</span>
                        </div>
                        : null
                      }
                    </div>
                    <div className={`priority-badge priority-${itemValue?.priority?.toLowerCase()}`}>
                      Priority {itemValue?.priority?.toLowerCase() === "low" ? "Low" 
                        : itemValue?.priority?.toLowerCase() === "high" ? "High" : "Medium"}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="noDataFound">No Data Found !!</div>
        )
        ) :
          (
            <div className="noDataFound">No Data Found !!</div>
          )
        }
      </div>
      
      {reqCard && reqCard.length > 0 && reqCard.length < totalCount && (
        <div className="view-more-container">
          <button
            className="view-more-btn"
            onClick={loadMoreData}
            disabled={isLoadingMore}
          >
            {isLoadingMore ? 'Loading...' : 'View More'}
          </button>
        </div>
      )}
    </div>
  );
};

export default RequisitionListCard;

